import axios from '@/config/http'
import ip from '../config/ip.js'


let base = ip.Ips.ip1
let webSocketBase = ip.Ips.webSocket
let base2 = ip.Ips.ip2


//webSocket
export const getWebSocket = `${webSocketBase}/messageSocket/`;

// 2018-11-12 登陆接口
export const login = params => { return axios.post(`${base}/user/login`, params); }

export const verifyCodeServlet = params => { return axios.post(`${base}/verifyCodeServlet`, params); }

//校验验证码
export const resultServlet = params => { return axios.get(`${base}/resultServlet`, { params: params }); }

//登出接口
export const logout = params => { return axios.post(`${base}/user/loginOut`, params) }

//修改密码 /user/resPwd
export const resPwd = params => { return axios.post(`${base}/user/resPwd`, params) }

export const getCode = params => { return axios.post(`${base}/api/sms/sms`, params) }

export const register = params => { return axios.post(`${base}/supplier`, params) }

export const verifyMobile = params => { return axios.get(`${base}/supplier`, { params: params }) }

export const findPass = params => { return axios.put(`${base}/password`, params) }

// by kaylaZhang 2018-10-23
//根据具体的菜单id查询功能权限
export const menuSelectAuthority = params => { return axios.get(`${base}/system/menu/selectAuthority/`, { params: params }); };

//获取模块菜单
export const menuRecursive = params => { return axios.post(`${base}/system/menu/menuRecursive`, params); };

//添加一二级菜单 /system/menu/add
export const menuAdd = params => { return axios.post(`${base}/system/menu/add`, params); };

//删除一二级菜单/system/menu/deletemenu
export const deletemenu = params => { return axios.post(`${base}/system/menu/deletemenu`, params); };

//根据菜单id查询需要修改的数据 /system/menu/selectByPrimaryKey
export const selectByPrimaryKey = params => { return axios.get(`${base}/system/menu/selectByPrimaryKey`, { params: params }); };

// 修改模块菜单 /system/menu/updatemenu
export const changeMenu = params => { return axios.post(`${base}/system/menu/updatemenu`, params); };

//删除具体功能 /system/menu/deleteAuthority
export const deleteAuthority = params => { return axios.post(`${base}/system/menu/deleteAuthority`, params); };

//修改功能权限 /system/menu/updateByPrimaryKey
export const updateByPrimaryKey = params => { return axios.post(`${base}/system/menu/updateByPrimaryKey`, params); };

//权限管理新增权限 /system/menu/insertAuthority
export const insertAuthority = params => { return axios.post(`${base}/system/menu/insertAuthority`, params); };



//日志查询/system/logging/selectlogging
export const selectlogging = params => { return axios.post(`${base}/system/logging/selectlogging`, params); };
export const loginLoggin = params => { return axios.post(`${base}/system/logging/selectLoginLogging`, params); };
export const selectLogs = params => { return axios.post(`${base}/system/logging/getLogs`, params); };
export const selectErrorLog = params => { return axios.post(`${base}/system/logging/getErrorLogs`, params); };
// 系统公告
export const selectNoticeAll = params => { return axios.post(`${base}/system/messageNotice/getAll`, params); };
export const selectNoticeInfo = params => { return axios.get(`${base}/system/messageNotice/getNotice`, { params: params }); };
export const getNoticeByDate = params => { return axios.get(`${base}/system/messageNotice/getNoticeByDate`, { params: params }); };
export const removeNotice = params => { return axios.get(`${base}/system/messageNotice/delete`, { params: params }); };
export const insertNotice = params => { return axios.post(`${base}/system/messageNotice/add`, params); };
export const updateNotice = params => { return axios.post(`${base}/system/messageNotice/update`, params); };
export const getNoticeMd = params => { return axios.get(`${base}/system/messageNotice/getIndex`, { params: params }); };
//飞书父类配置
export const selectFeishu = params => { return axios.post(`${base}/feishu/approve/find/page`, params); };
export const removeFeishu = params => { return axios.get(`${base}/feishu/approve/delete/${params.id}`); };
export const insertFeishu = params => { return axios.post(`${base}/feishu/approve/save`, params); };
export const updateFeishu = params => { return axios.post(`${base}/feishu/approve/update`, params); };
//飞书子类
export const entryFindFeishu = params => { return axios.post(`${base}/feishu/approve/entry/find/page`, params); };
export const insertFeishuEntry = params => { return axios.post(`${base}/feishu/approve/entry/save`, params); };
export const entryRemoveFeishu = params => { return axios.get(`${base}/feishu/approve/entry/delete/${params.id}`); };
export const entryUpdateFeishu = params => { return axios.post(`${base}/feishu/approve/entry/update`, params); };






// 任务调度
export const getQuartzList = params => { return axios.post(`${base}/system/scheduling/getQuartzList`, params); };
export const getQuartzInfo = params => { return axios.get(`${base}/system/scheduling/getInfo`, { params: params }); };
export const quartzAdd = params => { return axios.post(`${base}/system/scheduling/add`, params); };
export const quartzIsEnabled = params => { return axios.get(`${base}/system/scheduling/isEnabled`, { params: params }); };
export const quartzRemove = params => { return axios.get(`${base}/system/scheduling/remove`, { params: params }); };
export const updateQuartz = params => { return axios.post(`${base}/system/scheduling/update`, params); };
export const getLogQuartz = params => { return axios.get(`${base}/system/scheduling/getLogs`, { params: params }); };
export const quartzExecute = params => { return axios.get(`${base}/system/scheduling/execute`, { params: params }); };
// 业务参数设置 by kaylaZhang 2018-11-6-----------------------------------------------------------------------

//查询业务参数 /system/parameterInfoBusiness/selectParameterInfoBusiness
export const selectParameterInfoBusiness = params => { return axios.post(`${base}/system/parameterInfoBusiness/selectParameterInfoBusiness`, params); };

//根据租户查询业务参数 /system/parameterInfoBusiness/zhselectParameterInfoBusiness
export const zhselectParameterInfoBusiness = params => { return axios.post(`${base}/system/parameterInfoBusiness/zhselectParameterInfoBusiness`, params); };

//添加业务参数 /system/parameterInfoBusiness/insertBusiness
export const insertBusiness = params => { return axios.post(`${base}/system/parameterInfoBusiness/insertBusiness`, params); };

//查询修改 /system/parameterInfoBusiness/selectUpdateParameter
export const selectUpdateParameter = params => { return axios.get(`${base}/system/parameterInfoBusiness/selectUpdateParameter`, { params: params }); };

//修改业务参数 /system/parameterInfoBusiness/edit
export const parameterEdit = params => { return axios.post(`${base}/system/parameterInfoBusiness/edit`, params); };

//删除业务参数 /system/parameterInfoBusiness/deleteParameter
export const deleteParameter = params => { return axios.post(`${base}/system/parameterInfoBusiness/deleteParameter`, params); };


//查询租户管理信息/system/lessee/selectinfos
export const selectInfos = params => { return axios.post(`${base}/system/lessee/selectinfos`, params); };

//租户管理新增租户  /system/lessee/addinfos
export const addinfos = params => { return axios.post(`${base}/system/lessee/addinfos`, params); };

//根据ID获取租户信息 /system/lessee/edit
export const edit = params => { return axios.post(`${base}/system/lessee/edit`, params); };

//修改租户 /system/lessee/updateDdit
export const updateDdit = params => { return axios.post(`${base}/system/lessee/updateDdit`, params); };

//角色管理修改角色预览 /system/lessee/showEdit
export const showEdit = params => { return axios.post(`${base}/system/lessee/showEdit`, params); };

//租户授权 /system/lessee/inseRole
export const inseRole = params => { return axios.post(`${base}/system/lessee/inseRole`, params); };

//修改租户授权 /system/lessee/updateauthorization
export const updateauthorization = params => { return axios.post(`${base}/system/lessee/updateauthorization`, params); };

//新增租户管理员 /system/lessee/insetuser
export const insetuser = params => { return axios.post(`${base}/system/lessee/insetuser`, params); };

//租户管理员管理重置密码 /system/lessee/resetPassword
export const resetPassword = params => { return axios.get(`${base}/system/lessee/resetPassword`, { params: params }); };


//系统设置-----> 人员组织 by kaylaZhang 2018-10-30

//组织机构列表  /system/dept/getDeptlist
export const getDeptlist = params => { return axios.post(`${base}/system/dept/getDeptlist`, params); };

//根据组织机构获取用户列表 /system/dept/getUserListByDept
export const getUserListByDept = params => { return axios.post(`${base}/system/dept/getUserListByDept`, params); };

//组织机构新增 /system/dept/deptAdd
export const deptAdd = params => { return axios.post(`${base}/system/dept/deptAdd`, params); };

// 组织机构详情 /system/dept/getDeptlist
export const deptInfo = params => { return axios.post(`${base}/system/dept/deptInfo`, params); };

//组织机构修改 /system/dept/deptEdit
export const deptEdit = params => { return axios.post(`${base}/system/dept/deptEdit`, params); };

//组织机构删除 /system/dept/delDept
export const delDept = params => { return axios.post(`${base}/system/dept/delDept`, params); };

//用户基本信息详情 /system/dept/getUserInfoById
export const getUserInfoById = params => { return axios.post(`${base}/system/dept/getUserInfoById`, params); };

//新增用户 /system/dept/userAdd
export const userAdd = params => { return axios.post(`${base}/system/dept/userAdd`, params); };

//修改用户 /system/dept/userEdit
export const userEdit = params => { return axios.post(`${base}/system/dept/userEdit`, params); };

//禁用账户 /system/dept/userDis
export const userDis = params => { return axios.post(`${base}/system/dept/userDis`, params); };

//删除用户 /system/dept/userDel
export const userDel = params => { return axios.post(`${base}/system/dept/userDel`, params); };

//重置密码 /system/dept/userResPwd
export const userResPwd = params => { return axios.post(`${base}/system/dept/userResPwd`, params); };

//账号授权页面展示信息查询 /system/dept/getAuthInfo
export const getAuthInfo = params => { return axios.post(`${base}/system/dept/getAuthInfo`, params); };

// 账号授权 /system/dept/userAuth
export const userAuth = params => { return axios.post(`${base}/system/dept/userAuth`, params); };

// 角色授权 2018-11-7 by kaylaZhang

//角色列表 /system/role/getRoleList
export const getRoleList = params => { return axios.post(`${base}/system/role/getRoleList`, params); };

//新增角色 /system/role/roleAdd
export const roleAdd = params => { return axios.post(`${base}/system/role/roleAdd`, params); };

//修改角色 /system/role/roleEdit
export const roleEdit = params => { return axios.post(`${base}/system/role/roleEdit`, params); };

//角色删除 /system/role/roleDel
export const roleDel = params => { return axios.post(`${base}/system/role/roleDel`, params); };

//角色详情 /system/role/roleInfo
export const roleInfo = params => { return axios.post(`${base}/system/role/roleInfo`, params); };

//角色授权页面-展示数据获取 /system/role/roleAuthInfo
export const roleAuthInfo = params => { return axios.post(`${base}/system/role/roleAuthInfo`, params); };

//角色授权保存按钮 /system/role/roleAuth
export const roleAuth = params => { return axios.post(`${base}/system/role/roleAuth`, params); };


//

//基础设置模块 by kaylaZhang 2018-11-22 Thanksgiving day
//品牌品类型号配置 查询品牌1 /api/basicSetting/brand/selectAllBrand
export const selectAllBrand = params => { return axios.get(`${base}/api/basicSetting/brand/selectAllBrand`, { params: params }); };

//品牌品类型号配置 新增品牌1 /api/basicSetting/brand/insertBrand
export const insertBrand = params => { return axios.post(`${base}/api/basicSetting/brand/insertBrand`, params); };

//品牌品类型号配置 修改品牌1 /api/basicSetting/brand/updateBrand
export const updateBrand = params => { return axios.post(`${base}/api/basicSetting/brand/updateBrand`, params); };

//品牌品类型号配置 删除品牌1 /api/basicSetting/brand/deleteBrand
export const deleteBrand = params => { return axios.get(`${base}/api/basicSetting/brand/deleteBrand`, { params: params }); };

//品牌品类型号配置 查询品类2 /api/basicSetting/category/selectCategory
export const selectCategory = params => { return axios.get(`${base}/api/basicSetting/category/selectCategory`, { params: params }); };
export const selectCategoryPost = params => { return axios.post(`${base}/api/basicSetting/category/selectCategory`, params); };

//品牌品类型号配置 新增品类2 /api/basicSetting/category/insertCategory
export const insertCategory = params => { return axios.post(`${base}/api/basicSetting/category/insertCategory`, params); };

//品牌品类型号配置 修改品类2 /api/basicSetting/category/updateCategory
export const updateCategory = params => { return axios.post(`${base}/api/basicSetting/category/updateCategory`, params); };

//品牌品类型号配置 删除品类2 /api/basicSetting/category/deleteCategory
export const deleteCategory = params => { return axios.get(`${base}/api/basicSetting/category/deleteCategory`, { params: params }); };

//品牌品类型号配置 查询型号3 /api/basicSetting/model/selectModel
export const selectModel = params => { return axios.post(`${base}/api/basicSetting/model/selectModel`, params); };

//品牌品类型号配置 新增型号3 /api/basicSetting/model/insertModel
export const insertModel = params => { return axios.post(`${base}/api/basicSetting/model/insertModel`, params); };

//品牌品类型号配置 删除型号3 /api/basicSetting/model/deleteModel?modelId=sadas
export const deleteModel = params => { return axios.get(`${base}/api/basicSetting/model/deleteModel`, { params: params }); };

//品牌品类型号配置 修改型号3 /api/basicSetting/model/updateModel
export const updateModel = params => { return axios.post(`${base}/api/basicSetting/model/updateModel`, params); };

//品牌品类型号配置 查询故障大类 /api/basicSetting/faulttypes/selectMainfaultTypes
export const selectMainfaultTypes = params => { return axios.post(`${base}/api/basicSetting/faulttypes/selectMainfaultTypes`, params); };

//品牌品类型号配置 新增故障大类 /api/basicSetting/faulttypes/addModelType
export const addModelType = params => { return axios.post(`${base}/api/basicSetting/faulttypes/addModelType`, params); };

//品牌品类型号配置 删除故障大类 /api/basicSetting/faulttypes/updatemodelMainType
export const updatemodelMainType = params => { return axios.post(`${base}/api/basicSetting/faulttypes/updatemodelMainType`, params); };

//品牌品类型号配置 查询故障小类 /api/basicSetting/faulttypes/selectMainFaultSubclass
export const selectMainFaultSubclass = params => { return axios.post(`${base}/api/basicSetting/faultSubclass/selectMainFaultSubclass`, params); };

//品牌品类型号配置 新增故障小类 /api/basicSetting/faultSubclass/addFaultSubclass
export const addFaultSubclass = params => { return axios.post(`${base}/api/basicSetting/faultSubclass/addFaultSubclass`, params); };

//品牌品类型号配置 删除故障小类 /api/basicSetting/faultSubclass/updateByPrimaryKeySelectives
export const updateByPrimaryKeySelectives = params => { return axios.post(`${base}/api/basicSetting/faultSubclass/updateByPrimaryKeySelectives`, params); };

//上传图片 /admin/webServer/imgs
export const uploadImgs = params => { return axios.post(`${base}/api/admin/webServer/imgs`, params); };
// by tyy 基础设置模块  根据故障大类查询手机型号列表 /api/basicSetting/model/query_model
export const resonFaultGetModel = params => { return axios.post(`${base}/api/basicSetting/model/query_model`, params); };
//基础设置模块  根据故障大类和手机型号查询问题详情 /api/basicSetting/paticulars/query_paticulars
export const getQuestionList = params => { return axios.post(`${base}/api/basicSetting/paticulars/query_paticulars`, params); };
//基础设置模块 =>问答故障管理 查询所有问题列表 /api/basicSetting/question/get_question_info_all
export const getAllquestionList = params => { return axios.post(`${base}/api/basicSetting/question/get_question_info_all`, params); };
//基础设置模块 =>问答故障管理 查询所有图片信息 /api/basicSetting/paticularsImages/query_paticulars_images
export const allPicture = params => { return axios.post(`${base}/api/basicSetting/paticularsImages/query_paticulars_images`, params); };
//2b用户
export const businessUserQuery = params => { return axios.post(`${base}/api/basicSetting/businessUser/query/page`, params); };
export const businessUserSave = params => { return axios.post(`${base}/api/basicSetting/businessUser/save`, params) };
export const businessUserUpdate = params => { return axios.post(`${base}/api/basicSetting/businessUser/update/${params.id}`, params) };
export const businessUserDelete = params => { return axios.get(`${base}/api/basicSetting/businessUser/delete`, { params: params }) };

//颜色管理 添加颜色 /basicSetting/color/insertColor
export const insertColor = params => { return axios.post(`${base}/api/basicSetting/color/insertColor`, params); };

//颜色管理 查询颜色/api/basicSetting/color/selectAll
export const selectAll = params => { return axios.post(`${base}/api/basicSetting/color/selectAll`, params); };

//颜色管理 根据品牌型号查询颜色 /api/basicSetting/color/query_color
export const queryColor = params => { return axios.post(`${base}/api/basicSetting/color/query_color`, params); };

//颜色管理 修改颜色 /api/basicSetting/color/updateColor
export const updateColor = params => { return axios.post(`${base}/api/basicSetting/color/updateColor`, params); };

//颜色管理 修改颜色 /api/basicSetting/color/deleteColor?colorId=dwqewq
export const deleteColor = params => { return axios.get(`${base}/api/basicSetting/color/deleteColor`, { params: params }); };

//故障管理 查询故障大类 /api/basicSetting/faulttypes/selectfaultTypes
export const selectfaultTypes = params => { return axios.post(`${base}/api/basicSetting/faulttypes/selectfaultTypes`, params); };

//故障管理 新增故障大类 /api/basicSetting/faulttypes/insertFaultTypes
export const insertFaultTypes = params => { return axios.post(`${base}/api/basicSetting/faulttypes/insertFaultTypes`, params); };

//故障管理 修改故障大类 /api/basicSetting/faulttypes/updateFaultTypes
export const updateFaultTypes = params => { return axios.post(`${base}/api/basicSetting/faulttypes/updateFaultTypes`, params); };

//故障管理 删除故障大类 /api/basicSetting/faulttypes/deleteFaultTypes
export const deleteFaultTypes = params => { return axios.post(`${base}/api/basicSetting/faulttypes/deleteFaultTypes`, params); };

//故障管理 查询故障小类 /api/basicSetting/faultSubclass/selectFaultSubclass
// export const selectFaultSubclass = params => { return axios.post(`${base}/api/basicSetting/faultSubclass/selectFaultSubclass`,params ); };
export const selectFaultSubclass = params => { return axios.get(`${base}/api/basicSetting/faultSubclass/selectFaultSubclass`, { params: params }); };

//故障管理 新增故障小类 /api/basicSetting/faultSubclass/insertFaultSubclass
export const insertFaultSubclass = params => { return axios.post(`${base}/api/basicSetting/faultSubclass/insertFaultSubclass`, params); };

//故障管理 故障修改小类 /api/basicSetting/faultSubclass/updateFaultSubclass
export const updateFaultSubclass = params => { return axios.post(`${base}/api/basicSetting/faultSubclass/updateFaultSubclass`, params); };

//故障管理 删除故障小类 /api/basicSetting/faultSubclass/deleteFaultSubclass
export const deleteFaultSubclass = params => { return axios.post(`${base}/api/basicSetting/faultSubclass/deleteFaultSubclass`, params); };

//维修方式管理 新增维修方式 /api/basicSetting/Solution/insertSolution
export const insertSolution = params => { return axios.post(`${base}/api/basicSetting/Solution/insertSolution`, params); };

//维修方式管理 查询维修方式 /api/basicSetting/Solution/selectSolution
export const selectSolution = params => { return axios.post(`${base}/api/basicSetting/Solution/selectSolution`, params); };

//维修方式管理 修改维修方式 /api/basicSetting/Solution/updateSolution
export const updateSolution = params => { return axios.post(`${base}/api/basicSetting/Solution/updateSolution`, params); };

//维修方式管理 删除维修方式 /api/basicSetting/Solution/delete1Solution
export const deleteSolution = params => { return axios.post(`${base}/api/basicSetting/Solution/delete1Solution`, params); };

//故障维修方式 查询故障大类故障小类 /api/basicSetting/ModelFaultSolution/selectFaultTypes
export const selectModelFaultTypes = params => { return axios.post(`${base}/api/basicSetting/ModelFaultSolution/selectFaultTypes`, params); };

//故障维修方式 添加型号故障维修方式 /api/basicSetting/ModelFaultSolution/insertModelFaultSolution
export const insertModelFaultSolution = params => { return axios.post(`${base}/api/basicSetting/ModelFaultSolution/insertModelFaultSolution`, params); };

//故障维修方式 查询已添加故障大类小类维修方式 /api/basicSetting/ModelFaultSolution/selectModelFaultSolution
export const selectModelFaultSolution = params => { return axios.post(`${base}/api/basicSetting/ModelFaultSolution/selectModelFaultSolution`, params); };

//故障维修方式 禁用,启用型号故障维修方式 /api/basicSetting/ModelFaultSolution/deleteModelFaultSolution
export const deleteModelFaultSolution = params => { return axios.post(`${base}/api/basicSetting/ModelFaultSolution/deleteModelFaultSolution`, params); };

//故障维修方式 导出品牌品类维修方式解决方案 /api/basicSetting/ModelFaultSolution/exportModelFaultSolution
export const exportModelFaultSolution = params => { return axios.post(`${base}/api/basicSetting/ModelFaultSolution/exportModelFaultSolution`, params); };

//故障报价管理 查询品牌品类维修方式价格 /api/basicSetting/ModelFaultSolution/selectFaultSolutionPrice
export const selectFaultSolutionPrice = params => { return axios.post(`${base}/api/basicSetting/ModelFaultSolution/selectFaultSolutionPrice`, params); };

//故障报价管理 修改价格 /api/basicSetting/ModelFaultSolution/insertFaultSolutionPrice
export const insertFaultSolutionPrice = params => { return axios.post(`${base}/api/basicSetting/ModelFaultSolution/insertFaultSolutionPrice`, params); };

//物料绑定关系管理 查询物料绑定关系 /api/basicSetting/ModelFaultSolution/selectMaterialBindingRelationship
export const selectMaterialBindingRelationship = params => { return axios.post(`${base}/api/basicSetting/ModelFaultSolution/selectMaterialBindingRelationship`, params); };

//物料绑定关系管理 查询编码管理不分页 /api/basicSetting/MaterialManagement/selectMaterialManagements
export const selectMaterialManagements = params => { return axios.post(`${base}/api/basicSetting/MaterialManagement/selectMaterialManagements`, params); };

//物料绑定关系管理 新增物料绑定关系 /api/basicSetting/ModelFaultSolution/insertColorMaterial
export const insertColorMaterial = params => { return axios.post(`${base}/api/basicSetting/ModelFaultSolution/insertColorMaterial`, params); };

//物料绑定关系管理 修改物料绑定关系 /api/basicSetting/ModelFaultSolution/updateColorMaterial
export const updateColorMaterial = params => { return axios.post(`${base}/api/basicSetting/ModelFaultSolution/updateColorMaterial`, params); };




//服务sku管理 查询服务sku /api/basicSetting/servesku/selectservesku
export const selectServeSku = params => { return axios.post(`${base}/api/basicSetting/servesku/selectservesku`, params); };

//服务sku管理 新建服务sku管理 /api/basicSetting/servesku/insertservesku
export const insertServeSku = params => { return axios.post(`${base}/api/basicSetting/servesku/insertservesku`, params); };

//服务sku管理 修改服务sku /api/basicSetting/servesku/updateServeSku
export const updateServeSku = params => { return axios.post(`${base}/api/basicSetting/servesku/updateServeSku`, params); };



//物料分类管理 查询物料分类 /api/basicSetting/MaterialClassification/selectMaterialClassification
export const selectMaterialClassification = params => { return axios.post(`${base}/api/basicSetting/MaterialClassification/selectMaterialClassification`, params); };

//物料分类管理 新增物料分类管理 /api/basicSetting/MaterialClassification/insertMaterialClassification
export const insertMaterialClassification = params => { return axios.post(`${base}/api/basicSetting/MaterialClassification/insertMaterialClassification`, params); };

//物料分类管理 修改物料分类 /api/basicSetting/MaterialClassification/updateMaterialClassification
export const updateMaterialClassification = params => { return axios.post(`${base}/api/basicSetting/MaterialClassification/updateMaterialClassification`, params); };


//物料编码管理 查询物料分类 /api/basicSetting/MaterialClassification/selectMaterialClassifications
export const selectMaterialClassifications = params => { return axios.post(`${base}/api/basicSetting/MaterialClassification/selectMaterialClassifications`, params); };

//物料编码管理 查询物料编码 /api/basicSetting/MaterialManagement/selectMaterialManagement
export const selectMaterialManagement = params => { return axios.post(`${base}/api/basicSetting/MaterialManagement/selectMaterialManagement`, params); };

//物料编码管理 添加物料编码 /api/basicSetting/MaterialManagement/insertMaterialManagement
export const insertMaterialManagement = params => { return axios.post(`${base}/api/basicSetting/MaterialManagement/insertMaterialManagement`, params); };

//物料编码管理 修改物料编码 /api/basicSetting/MaterialManagement/updateMaterialManagement
export const updateMaterialManagement = params => { return axios.post(`${base}/api/basicSetting/MaterialManagement/updateMaterialManagement`, params); };

//物料配送管理 配送列表 /api/distribution/selectDistributionList
export const selectDistributionList = params => { return axios.post(`${base}/api/distribution/selectDistributionList`, params); };

//物料配送管理 新建物料配送 /api/distribution/insertDistribution
export const insertDistribution = params => { return axios.post(`${base}/api/distribution/insertDistribution`, params); };

//物料配送管理 物料详情 /api/distribution/selectTheShippingDelivery
export const selectTheShippingDelivery = params => { return axios.post(`${base}/api/distribution/selectTheShippingDelivery`, params); };

//物料配送管理 物料详情分页 /api/distribution/selectDeliveryTheGoodsList
export const selectDeliveryTheGoodsList = params => { return axios.post(`${base}/api/distribution/selectDeliveryTheGoodsList`, params); };

//物料配送管理 物料详情取消配送 /api/distribution/cancel
export const cancel = params => { return axios.post(`${base}/api/distribution/cancel`, params); };

//物料配送管理 物料详情确认收货 /api/distribution/confirm_receipt
export const confirmReceipt = params => { return axios.post(`${base}/api/distribution/confirm_receipt `, params); };

//废宝类型管理 查询废宝 /api/basicSetting/wasteTreasure/selectWasteTreasure
export const selectWasteTreasure = params => { return axios.get(`${base}/api/basicSetting/wasteTreasure/selectWasteTreasure`, { params: params }); };

// export const selectWasteTreasure = params => { return axios.post(`${base}/api/basicSetting/wasteTreasure/selectWasteTreasure`,params ); };

//废宝类型管理 修改废宝类型 /api/basicSetting/wasteTreasure/updateWasteTreasure
export const updateWasteTreasure = params => { return axios.post(`${base}/api/basicSetting/wasteTreasure/updateWasteTreasure`, params); };

//废宝类型管理 新增废宝类型 /api/basicSetting/wasteTreasure/insertWasteTreasure
export const insertWasteTreasure = params => { return axios.post(`${base}/api/basicSetting/wasteTreasure/insertWasteTreasure`, params); };

//工程师等级管理 工程师等级列表 /api/engineerGrade/engineerGreadeList
export const engineerGreadeList = params => { return axios.post(`${base}/api/engineerGrade/engineerGreadeList`, params); };

//工程师等级管理 工程师基础包删除 /api/engineerPackType/delete_pack
export const engineerPackDelete = params => { return axios.get(`${base}/api/engineerPackType/delete_pack`, { params: params }); };

//工程师等级管理 工程师等级新增 /api/engineerGrade/engineerGreadeAdd
export const engineerGreadeAdd = params => { return axios.post(`${base}/api/engineerGrade/engineerGreadeAdd`, params); };

//工程师等级管理 工程师等级编辑 /api/engineerGrade/engineerGreadeEdit
export const engineerGreadeEdit = params => { return axios.post(`${base}/api/engineerGrade/engineerGreadeEdit`, params); };

//工程师等级管理 根据条件带出所有故障，并标注已选择的
export const faultSubclassByMode = params => { return axios.post(`${base}/api/engineerGrade/faultSubclassByMode`, params); };

//工程师等级管理 按照条件保存所选故障
export const engineerGreadeEditFs = params => { return axios.post(`${base}/api/engineerGrade/engineerGreadeEditFs`, params); };

//工程师基础包管理 基础包列表 /api/engineerPackType/packTypeList
export const packTypeList = params => { return axios.post(`${base}/api/engineerPackType/packTypeList`, params); };

//工程师基础包管理 基础包新增 /api/engineerPackType/packTypeAdd
export const packTypeAdd = params => { return axios.post(`${base}/api/engineerPackType/packTypeAdd`, params); };

//工程师基础包管理 基础包编辑 /api/engineerPackType/packTypeEdit
export const packTypeEdit = params => { return axios.post(`${base}/api/engineerPackType/packTypeEdit`, params); };

//工程师基础包管理 根据品牌品类型号加载已选物料 /api/engineerPackType/packTypeByWs
export const packTypeByWs = params => { return axios.post(`${base}/api/engineerPackType/packTypeByWs`, params); };

//工程师基础包管理 基础包新增物料 /api/engineerPackType/packTypeEditByWs
export const packTypeEditByWs = params => { return axios.post(`${base}/api/engineerPackType/packTypeEditByWs`, params); };



//仓库管理
//库存查询(非冻结) 列表展示 POST /api/inventory/list(过期)
export const inventoryList = params => { return axios.post(`${base}/api/inventory/inventory_list`, params); };
//库存查询(冻结)(过期)
export const inventoryListFrozen = params => { return axios.post(`${base}/api/inventory/inventory_list_frozen`, params); };
//库存查询 2020/03/05
export const queryWarehouseTypeList = params => { return axios.post(`${base}/api/inventory/inventory/warehouseType`, params); };
//库存查询 查看序列号 POST /api/inventory/all_serial_number
export const inventorySerial = params => { return axios.post(`${base}/api/inventory/all_serial_number`, params); };
// 查询小码
export const inventorySearchSn = params => { return axios.post(`${base}/api/inventory/query/sn`, params); };
//工程师库存查询 POST /api/inventory/engineer_inventory_list
export const engineerInventoryList = params => { return axios.post(`${base}/api/inventory/engineer_inventory_list`, params); };
//工程师库存查询 查看序列号 POST /api/inventory/engineer_inventory_list
export const engineerSerialList = params => { return axios.post(`${base}/api/inventory/all_serial_number`, params); };


//仓库管理 物料流转记录查询 POST /api/suppliesFlow/suppliesFlowList
export const suppliesFlowList = params => { return axios.post(`${base}/api/suppliesFlow/suppliesFlowList`, params); };
//仓库管理 物料转库管理列表 POST /api/transferLibrary/transferLibraryList
export const transferLibraryList = params => { return axios.post(`${base}/api/transferLibrary/transferLibraryList`, params); };
//仓库管理 物料转库管理 新建转库 POST /api/transferLibrary/transferLibraryAdd
export const transferLibraryAdd = params => { return axios.post(`${base}/api/transferLibrary/transferLibraryAdd`, params); };
//仓库管理 物料转库管理 转库详情 POST /api/transferLibrary/transferLibraryDetails
export const transferLibraryDetails = params => { return axios.post(`${base}/api/transferLibrary/transferLibraryDetails`, params); };
//仓库管理 物料转库管理 转库详情 POST /api/transferLibrary/transfer_library_details_list
export const transferLibraryDetailsList = params => { return axios.post(`${base}/api/transferLibrary/transfer_library_details_list`, params); };

//仓库管理 出入库列表查询 POST /api/inbound/inboundList
export const inboundList = params => { return axios.post(`${base}/api/inbound/inboundList`, params); };

//仓库管理 新建入库 POST /api/inbound/inboundAdd
export const inboundAdd = params => { return axios.post(`${base}/api/inbound/inboundAdd`, params); };
//仓库管理 新建入库 物料出库添加序列号 GET /api/inventory/get_by_serial_number
export const getBySerialNumber = params => { return axios.get(`${base}/api/inventory/get_by_serial_number`, { params: params }); }
//仓库管理 新建入库 物料出库添加序列号 POST /api/inventory/query_by_serial_number
export const queryBySerialNumber = params => { return axios.post(`${base}/api/inventory/query_by_serial_number`, params); }

//仓库管理 查询出入库数量 POST /api/inbound/get_count
export const get_count = params => { return axios.post(`${base}/api/inbound/get_count`, params); };

//仓库管理 新建入库详情 POST /api/inbound/inboundDetails
export const inboundDetails = params => { return axios.post(`${base}/api/inbound/inboundDetails`, params); };
//仓库管理 新建入库详情分页 POST /api/inbound/inboundDetailsList
export const inboundDetailsList = params => { return axios.post(`${base}/api/inbound/inboundDetailsList`, params); };

//仓库管理 暂存 POST /api/inbound/save
export const inboundSave = params => { return axios.post(`${base}/api/inbound/save`, params); };
//仓库管理 修改暂存 POST /api/inbound/saveAndUpdate
export const saveAndUpdate = params => { return axios.post(`${base}/api/inbound/saveAndUpdate`, params); };
//仓库管理 删除暂存目录 POST /api/inbound/removeEntry
export const removeEntry = params => { return axios.post(`${base}/api/inbound/removeEntry`, params); };
//仓库管理 删除暂存 POST /api/inbound/remove
export const inboundRemove = params => { return axios.get(`${base}/api/inbound/remove`, { params: params }); };
//仓库管理 暂存提交与修改 POST /api/inbound/updateAndSubmit
export const inboundUpdateAndSubmit = params => { return axios.post(`${base}/api/inbound/updateAndSubmit`, params); };

//仓库管理 领料管理 领料列表 POST /api/picking/pickingList
export const pickingList = params => { return axios.post(`${base}/api/picking/pickingList`, params); };
//仓库管理 领料管理 新增领料 POST /api/picking/pickingAdd
export const pickingAdd = params => { return axios.post(`${base}/api/picking/pickingAdd`, params); };
//仓库管理 领料管理 领料详情 POST /api/picking/pickingDetails
export const pickingDetails = params => { return axios.post(`${base}/api/picking/pickingDetails`, params); };
//仓库管理 领料管理 扫码查询 POST /api/picking/wsBySn
export const wsBySn = params => { return axios.post(`${base}/api/picking/wsBySn`, params); };
//仓库管理 领料管理 申领人列表 POST /api/picking/engineerList
export const applyEnginnerList = params => { return axios.post(`${base}/api/picking/engineerList`, params); };
//仓库管理 领料管理 领料详情 POST /api/picking/query_picking_details
export const queryPickingDetails = params => { return axios.post(`${base}/api/picking/query_picking_details`, params); };
//仓库管理 领料暂存 POST /api/picking/save
export const pickingSave = params => { return axios.post(`${base}/api/picking/save`, params); };
//仓库管理 领料暂存修改 POST /api/picking/saveAndUpdate
export const pickingSaveAndUpdate = params => { return axios.post(`${base}/api/picking/saveAndUpdate`, params); };
//仓库管理 领料表头修改 POST /api/picking/update
export const pickingUpdate = params => { return axios.post(`${base}/api/picking/update`, params); };
//仓库管理 领料暂存提交与修改 POST /api/picking/updateAndSubmit
export const updateAndSubmit = params => { return axios.post(`${base}/api/picking/updateAndSubmit`, params); };
//仓库管理 领料暂存分录删除 POST /api/picking/removeEntry
export const pickingRemoveEntry = params => { return axios.post(`${base}/api/picking/removeEntry`, params); };
//仓库管理 领料暂存删除 POST /api/picking/remove
export const pickingRemove = params => { return axios.get(`${base}/api/picking/remove`, { params: params }); };

//仓库管理 退料管理 退料类型 POST /api/returnMaterial/returnMaterialType
export const returnMaterialType = params => { return axios.post(`${base}/api/returnMaterial/returnMaterialType`, params); };
//仓库管理 退料管理 退料列表 POST /api/returnMaterial/returnMaterialList
export const returnMaterialList = params => { return axios.post(`${base}/api/returnMaterial/returnMaterialList`, params); };
//仓库管理 退料管理 废宝类型列表 POST /api/returnMaterial/wasteTreasureType
export const wasteTreasureType = params => { return axios.post(`${base}/api/returnMaterial/wasteTreasureType`, params); };
//仓库管理 退料管理 新增退料 POST /api/returnMaterial/returnMaterialAdd
export const returnMaterialAdd = params => { return axios.post(`${base}/api/returnMaterial/returnMaterialAdd`, params); };
//仓库管理 退料管理 退料详情 GET /api/returnMaterial/get_detail_info
export const returnMaterialDetails = params => { return axios.get(`${base}/api/returnMaterial/get_detail_info`, { params: params }); };
//仓库管理 退料管理 退料详情分页 POST /api/returnMaterial/return_material_detail_list
export const returnMaterialDetailsList = params => { return axios.post(`${base}/api/returnMaterial/return_material_detail_list`, params); };
//仓库管理 退料管理 新建退料 根据小码查询物料 POST /api/scrap_value_manager/query_by_serial_number_and_rt
export const queryMaterialBySerialNumber = params => { return axios.post(`${base}/api/scrap_value_manager/query_by_serial_number_and_rt`, params); };
//仓库管理 退料管理 新建退料 POST /api/returnMaterial/returnMaterial_add
export const addReturnMaterial = params => { return axios.post(`${base}/api/returnMaterial/returnMaterial_add`, params); };
//仓库管理 退料管理 退料列表 POST /api/returnMaterial/return_material_list
export const returnMaterialDataList = params => { return axios.post(`${base}/api/returnMaterial/return_material_list`, params); };
//仓库管理 退料暂存 POST /api/returnMaterial/save
export const returnMaterialSave = params => { return axios.post(`${base}/api/returnMaterial/save`, params); };
//仓库管理 退料暂存修改 POST /api/returnMaterial/saveAndUpdate
export const returnSaveAndUpdate = params => { return axios.post(`${base}/api/returnMaterial/saveAndUpdate`, params); };
//仓库管理 退料提交修改 POST /api/returnMaterial/updateAndSubmit
export const returnUpdateAndSubmit = params => { return axios.post(`${base}/api/returnMaterial/updateAndSubmit`, params); };
//仓库管理 退料分录删除 POST /api/returnMaterial/removeEntry
export const returnRemoveEntry = params => { return axios.post(`${base}/api/returnMaterial/removeEntry`, params); };
//仓库管理 退料暂存删除 POST /api/returnMaterial/remove
export const returnMaterialRemove = params => { return axios.get(`${base}/api/returnMaterial/remove`, { params: params }); };

//仓库管理 库存盘点 库存盘点列表 POST /api/verification/verification_list
export const verificationList = params => { return axios.post(`${base}/api/verification/verification_list`, params); };
//仓库管理 库存盘点 新建盘点 导入库存信息 POST /api/verification/import_inventory_data
export const importInventoryData = params => { return axios.post(`${base}/api/verification/import_inventory_data`, params); };
//仓库管理 库存盘点 新建盘点 导入库存信息 POST /api/verification/verification_add
export const verificationAdd = params => { return axios.post(`${base}/api/verification/verification_add`, params); };
//仓库管理 库存盘点 盘点详情 导入库存信息 POST /api/verification/verification_detail_info
export const verificationDetailInfo = params => { return axios.post(`${base}/api/verification/verification_detail_info`, params); };
//仓库管理 库存盘点 盘点详情分页 导入库存信息 POST /api/verification/verification_detail_list
export const verificationDetailList = params => { return axios.post(`${base}/api/verification/verification_detail_list`, params); };

//工单管理模块  订单=> by tyy 2019-11-29 /api/inventory/query_lessee_inventory
export const getQueryMaterial = params => { return axios.post(`${base}/api/inventory/query_lessee_inventory`, params); };
//工单管理模块  订单=> by tyy 2019-11-29 /api/workOrder/order/replenish_mat
export const addMaterial = params => { return axios.post(`${base}/api/workOrder/order/replenish_mat`, params); };
// 订单地图
export const queryOrderMap = params => { return axios.post(`${base}/api/orderMap/query`, params); };
// 将地址解析位经纬度
export const queryAddressGeocoder = params => { return axios.get(`${base}/api/orderMap/geocoder`, { params: params }); };
// 门店订单地图
export const queryShopStoreOrderMap = params => { return axios.post(`${base}/api/orderMap/shop_store`, params); };


//采购管理模块 by kayla 2018-11-27
//供应商管理 供应商新增 /api/supplier/supplierAdd
export const supplierAdd = params => { return axios.post(`${base}/api/supplier/supplierAdd`, params); };

//供应商管理 供应商下拉列表 /api/supplier/getsupplierList
export const getsupplierList = params => { return axios.post(`${base}/api/supplier/getsupplierList`, params); };

//供应商管理 供应商修改 /api/supplier/supplierEdit
export const supplierEdit = params => { return axios.post(`${base}/api/supplier/supplierEdit`, params); };

//供应商管理 账期列表 /api/supplier/getpaymentDayList
export const getpaymentDayList = params => { return axios.post(`${base}/api/supplier/getpaymentDayList`, params); };

//采购订单管理 供应商下拉列表 /api/purchase/getsupplierList
export const supplierList = params => { return axios.post(`${base}/api/purchase/getsupplierList`, params); };

//采购订单管理 物料列表-多条件筛选 /api/purchase/getMaterialList
export const getMaterialList = params => { return axios.post(`${base}/api/purchase/getMaterialList`, params); };

//采购订单管理 物料列表-多条件筛选 /api/purchase/getMaterialList
export const getMaterialListByWarehouse = params => { return axios.post(`${base}/api/purchase/getMaterialListByWarehouse`, params); };

//采购订单管理 采购管理列表 /api/purchase/getpurchaseOrdersList
export const getpurchaseOrdersList = params => { return axios.post(`${base}/api/purchase/getpurchaseOrdersList`, params); };

//采购订单管理 采购订单详情 /api/purchase/getPurchaseOrdersInfo
export const getPurchaseOrdersInfo = params => { return axios.post(`${base}/api/purchase/getPurchaseOrdersInfo`, params); };

//采购订单管理 新增采购订单 /api/purchase/purchaseOrdersAdd
export const purchaseOrdersAdd = params => { return axios.post(`${base}/api/purchase/purchaseOrdersAdd`, params); };

//采购订单管理  物料列表-多条件筛选 /api/purchase/getMaterialList
// export const purchaseOrdersAdd = params => { return axios.post(`${base}/api/purchase/getMaterialList`,params ); };


//采购订单管理 修改暂存采购订单 /api/purchase/purchaseOrdersEdit
export const purchaseOrdersEdit = params => { return axios.post(`${base}/api/purchase/purchaseOrdersEdit`, params); };

//采购订单管理 删除草稿采购单 /api/purchase/delPurchasingInfo
export const delPurchasingInfo = params => { return axios.post(`${base}/api/purchase/delPurchasingInfo`, params); };

//采购订单管理 手动关闭 /api/purchase/purchaseOrdersClose
export const purchaseOrdersClose = params => { return axios.post(`${base}/api/purchase/purchaseOrdersClose`, params); };

//采购订单变更管理 采购变更单列表 /api/purchase/purchasingChangeList
export const purchasingChangeList = params => { return axios.post(`${base}/api/purchase/purchasingChangeList`, params); };

//采购订单变更管理 采购变更单详情 /api/purchase/getpurchasingChangeInfo
export const getpurchasingChangeInfo = params => { return axios.post(`${base}/api/purchase/getpurchasingChangeInfo`, params); };

//采购订单变更管理 采购单下拉列表 /api/purchase/getpurchasingChanges
export const getPurchasingChanges = params => { return axios.post(`${base}/api/purchase/getpurchasingChanges`, params); };

//采购订单变更管理 采购变更新增 /api/purchase/purchasingChangeAdd
export const purchasingChangeAdd = params => { return axios.post(`${base}/api/purchase/purchasingChangeAdd`, params); };

//采购订单变更管理 删除草稿采购变更单 /api/purchase/delpurchasingChangeInfo
export const delpurchasingChangeInfo = params => { return axios.post(`${base}/api/purchase/delpurchasingChangeInfo`, params); };

//采购订单变更管理 修改暂存采购变更单 /api/purchase/purchasingChangeEdit
export const purchasingChangeEdit = params => { return axios.post(`${base}/api/purchase/purchasingChangeEdit`, params); };

//采购退货管理 采购退货列表
export const purchasingReturnList = params => { return axios.post(`${base}/api/purchase/purchasingReturnList`, params); };

//采购退货管理 采购退货详情
export const purchasingReturnDetails = params => { return axios.post(`${base}/api/purchase/purchasingReturnDetails`, params); };


//门店管理 门店列表 /api/shop/shopList
export const shopList = params => { return axios.post(`${base}/api/shop/shopList`, params); };
export const shopStoreList = parmas => { return axios.post(`${base}/api/shop/get_shop_List`, parmas) };
export const shopExport = params => { return axios.post(`${base}/api/shop/export`, params, { responseType: 'blob' }); };
export const shopImptmpl = params => { return axios.post(`${base}/api/shop/imptpl`, params, { responseType: 'blob' }); };
export const shopImport = params => { return axios.post(`${base}/api/shop/import`, params, { Headers: { "Content-Type": "multipart/form-data" } }); };

//门店管理 非当前登录组织下的门店列表 /api/shop/shopListNonLoginDetId
export const shopListNonLoginDetId = params => { return axios.post(`${base}/api/shop/shopListNonLoginDetId`, params); };

//门店管理 新建门店 /api/shop/shopAdd
export const shopAdd = params => { return axios.post(`${base}/api/shop/shopAdd`, params); };

//门店管理 编辑门店 /api/shop/shopEdit
export const shopEdit = params => { return axios.post(`${base}/api/shop/shopEdit`, params); };

//门店管理 门店详情 /api/shop/shopDetails
export const shopDetails = params => { return axios.post(`${base}/api/shop/shopDetails`, params); };

//工程师管理 工程师列表 /api/EngineerInfo/engineerList
export const engineerList = params => { return axios.post(`${base}/api/EngineerInfo/engineerList`, params); };

//工程师管理 工程师类别下拉 /api/EngineerInfo/engineerInfoTypeList
export const engineerInfoTypeList = params => { return axios.post(`${base}/api/EngineerInfo/engineerInfoTypeList`, params); };

//工程师管理 用户下拉列表 /api/EngineerInfo/engineerInfoByUser
export const engineerInfoByUser = params => { return axios.post(`${base}/api/EngineerInfo/engineerInfoByUser`, params); };

//工程师管理 工程师详情 /api/EngineerInfo/engineerDetails
export const engineerDetails = params => { return axios.post(`${base}/api/EngineerInfo/engineerDetails`, params); };

//工程师管理 工程师编辑 /api/EngineerInfo/engineerInfoEdit
export const engineerInfoEdit = params => { return axios.post(`${base}/api/EngineerInfo/engineerInfoEdit`, params); };

//工程师管理 工程师新建 /api/EngineerInfo/engineerInfoAdd
export const engineerInfoAdd = params => { return axios.post(`${base}/api/EngineerInfo/engineerInfoAdd`, params); };


//客服管理  客服列表查询
export const queryCustomerServices = params => { return axios.post(`${base}/api/customer_services/query_customer_services`, params); };
//客服管理  新建客服
export const createServices = params => { return axios.post(`${base}/api/customer_services/create_services`, params); };
//客服管理  查询客服账号
export const queryUser = params => { return axios.get(`${base}/api/customer_services/query_user`, { params: params }); };
//客服管理  修改客服
export const updateServices = params => { return axios.post(`${base}/api/customer_services/update_customer_services`, params); };

//客户管理  客户列表查询
export const queryClient = params => { return axios.post(`${base}/api/workOrder/client_basic_information/query`, params); };
//客户管理  客户详情查询
export const ClientDetails = params => { return axios.get(`${base}/api/workOrder/client_basic_information/details`, { params: params }); };
//客户管理  客户详情列表查询
export const ClientDetailsList = params => { return axios.post(`${base}/api/workOrder/order/selectWorkOrder`, params); };

//库存管理  废料残值列表查询
export const wasteList = params => { return axios.post(`${base}/api/basicSetting/material_residual/query_material_residual`, params); };
//库存管理  废料残值新建
export const wasteAdd = params => { return axios.post(`${base}/api/scrap_value_manager/add`, params); };
//库存管理  废料残值单详情
export const wasteInfo = params => { return axios.get(`${base}/api/scrap_value_manager/get_detail`, { params: params }); };
//库存管理  残值单详情页列表查询
export const wasteInfoList = params => { return axios.post(`${base}/api/scrap_value_manager/query_detail`, params); };
//库存管理  新建废料残值定价 根据品牌品类型号颜色查询物料
export const selectMaterialByColor = params => { return axios.post(`${base}/api/basicSetting/MaterialManagement/selectMaterialByColor`, params); };
//库存管理  新建废料残值定价 新建
export const addMaterialResidual = params => { return axios.post(`${base}/api/basicSetting/material_residual/add_material_residual`, params); };
//库存管理  新建废料残值定价 修改&删除
export const updateMaterialResidual = params => { return axios.post(`${base}/api/basicSetting/material_residual/update_material_residual`, params); };


//库存管理  门店维修出入库管理  查询门店库存
export const shopInventoryList = params => { return axios.post(`${base}/api/shopInventory/query`, params); };
//库存管理  门店维修出入库管理  确认收到
export const confirmEnsure = params => { return axios.post(`${base}/api/shopInventory/ensure`, params); };
//库存管理  门店维修出入库管理  结束订单
export const finishOrder = params => { return axios.post(`${base}/api/shopInventory/finish_order`, params); };
//库存管理  门店维修出入库管理  生成取机码
export const createCode = params => { return axios.get(`${base}/api/shopInventory/create_code`, { params: params }); };

//退料管理 查询收料人&系统用户
export const queryUserList = params => { return axios.post(`${base}/system/dept/queryUserList`, params); };


//库存查询  数据导出 /api/export/export_warehouse
export const exportWarehouse = params => { return axios.post(`${base}/api/export/export_warehouse`, params); };

//批量出库
export const exportEnsureBatch = params => { return axios.post(`${base}/api/shopInventory/ensure_batch`, params); };

//小码生命周期
export const querySnLife = params => { return axios.post(`${base}/api/snLife/query`, params); };
export const getCurrentOrg = params => { return axios.get(`${base}/api/snLife/getCurrentOrg`, { params: params }); };
export const getLifeCycle = params => { return axios.get(`${base}/api/snLife/getLifeCycle`, { params: params }) };

// 物料小码绑定
export const getBinderAll = params => { return axios.post(`${base}/api/binding/getBinderAll`, params); };
export const getBinderInfo = params => { return axios.get(`${base}/api/binding/getBinderInfo`, { params: params }); };
export const addMaterialBinding = params => { return axios.post(`${base}/api/binding/addBinding`, params); };
export const updateBinding = params => { return axios.post(`${base}/api/binding/update`, params); };
export const deleteBinding = params => { return axios.get(`${base}/api/binding/delete`, { params: params }); };

// 残值利润
export const queryScrapProfitPage = params => { return axios.post(`${base}/api/scrapProfit/page`, params); };
export const scrapProfitUpload = params => {
  const config = {
    Headers: { "Content-Type": "multipart/form-data" }
  }
  return axios.post(`${base}/api/scrapProfit/upload`, params, config);
};
export const scrapProfitExport = params => {
  return axios.post(`${base}/api/scrapProfit/export`, params, { responseType: 'blob' });
}

//图文查询
export const selectTweet = params => { return axios.post(`${base}/api/basicSetting/tweetPictures/find`, params); };
//修改图文
export const updateDetails = params => { return axios.post(`${base}/api/basicSetting/tweetPictures/updateDetails`, params); };
//新增图文
export const insertTweet = params => { return axios.post(`${base}/api/basicSetting/tweetPictures/save`, params); };



//预授权查询
export const fundAuthListList = params => { return axios.post(`${base}/api/appletAli/fundAuthList`, params); };
//解冻预授权
export const orderUnfreeze = params => { return axios.post(`${base}/api/appletAli/orderUnfreeze`, params); };
//冻结转支付
export const tradePay = params => { return axios.post(`${base}/api/appletAli/tradePay`, params); };

// 小程序型号适配
// 查询
export const modelAdapterList = params => {
  return axios.get(
    `${base}/base/model/adapter/list`,
    { params: params }
  );
};
// 新增与修改
export const modelAdapterSave = params => {
  return axios.post(
    `${base}/base/model/adapter/save`,
    params
  );
};
// 删除
export const modelAdapterDelete = params => {
  return axios.delete(
    `${base}/base/model/adapter/delete`,
    { params: params }
  );
};


//回收利润率 /recovery/profit/getFareIncreaseList
export const getFareIncreaseList = params => { return axios.post(`${base}/recovery/profit/getFareIncreaseList`, params); };

//回收利润率新增 /recovery/profit/add
export const recoveryAdd = params => { return axios.post(`${base}/recovery/profit/add`, params); };

//回收利润率修改 /recovery/profit/update
export const recoveryUpdate = params => { return axios.post(`${base}/recovery/profit/update`, params); };

//删除回收利润率
export const recoveryDelete = params => { return axios.get(`${base}/recovery/profit/delete`, { params: params }); };


//回收询价记录 /recovery/profit/getRecycleHistory
export const getRecycleHistoryList = params => { return axios.post(`${base}/recovery/params/getRecycleHistoryList`, params); };


//回收询价导出 /recovery/profit/recyclingExports
export const recyclingExports = params => { return axios.post(`${base}/recovery/params/recyclingExports`, params); };

// 回收-门店-查询
export const recoveryShopQuery = params => { return axios.get(`${base}/recovery/shop/page`, { params: params }); }
export const recoveryShopAccountExited = params => { return axios.get(`${base}/recovery/shop/exist/account`, { params: params }); }
export const recoveryShopSave = params => { return axios.post(`${base}/recovery/shop`, params); }
export const recoveryShopUpdate = params => { return axios.put(`${base}/recovery/shop`, params); }
export const recoveryShopDelete = params => { return axios.delete(`${base}/recovery/shop`, { params: params }); }
export const recoveryShopUnBound = id => { return axios.put(`${base}/recovery/shop/unbound`, {}, { params: { id: id } }) }
// 回收-apk
export const recoveryShopApkVersionQuery = params => { return axios.get(`${base}/recovery/shop/apk/version/page`, { params: params }); }
export const recoveryShopApkVersionSave = params => { return axios.post(`${base}/recovery/shop/apk/version`, params); }
export const recoveryShopApkVersionUpdate = params => { return axios.put(`${base}/recovery/shop/apk/version`, params); }
export const recoveryShopApkVersionDelete = params => { return axios.delete(`${base}/recovery/shop/apk/version`, { params: params }); }



// WEBPACK FOOTER //
// ./src/api/api.js